import React, { Component } from 'react';
import { authentication } from '../services/Authentication';
import { withRouter } from "react-router-dom";

import { config } from '../Constants';
import moment from 'moment';
import helpers from '../Function';
import ReactExport from 'react-data-export';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import $ from "jquery"
import Multiselect from 'react-widgets/lib/Multiselect'

import LoadingOverlay from 'react-loading-overlay';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class ReportHomeCare extends Component {

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission, project_id } = authentication.currentUserValue;

        const style = {
            border: {
                top: { style: "thin", color: { rgb: "000000" } }
                , left: { style: "thin", color: { rgb: "000000" } }
                , right: { style: "thin", color: { rgb: "000000" } }
                , bottom: { style: "thin", color: { rgb: "000000" } }
            }
            , font: { name: "Tahoma", sz: "10" }
            , fill: { patternType: "solid", fgColor: { rgb: "E8EFF5" } }
        }

        this.state = {
            PROJECTID: project_id,
            user_permission: user_permission,
            pages: [{ number: ' ' }],
            dataReport: [],
            project_home: [],
            service_category: [],
            group_type: [],
            service_type: [],
            DataSetWorkSheet: [{
                columns: [
                    { title: "เลขที่", width: { wpx: 100 }, style },
                    { title: "วันที่รับเรื่อง", width: { wpx: 150 }, style },
                    { title: "เวลา", width: { wpx: 100 }, style },
                    { title: "ผู้แจ้ง", width: { wpx: 150 }, style },
                    { title: "เบอร์โทรเข้า", width: { wpx: 150 }, style },
                    { title: "โครงการ", width: { wpx: 300 }, style },
                    { title: "บ้านเลขที่", width: { wpx: 100 }, style },
                    { title: "สถานะ", width: { wpx: 100 }, style },
                    { title: "ระยะเวลาประกัน", width: { wpx: 200 }, style },
                    { title: "เร่งด่วน", width: { wpx: 80 }, style },
                    { title: "หมวดเรื่อง", width: { wpx: 100 }, style },
                    { title: "เรื่องย่อย", width: { wpx: 200 }, style },
                    { title: "รายละเอียด", width: { wpx: 300 }, style },
                    { title: "สถานะใบงาน", width: { wpx: 150 }, style },
                    { title: "Agent", width: { wpx: 150 }, style },
                    { title: "SLA เรื่องย่อย", width: { wpx: 100 }, style },
                    { title: "SLA Case", width: { wpx: 100 }, style },
                    { title: "วันที่ปิดใบงาน", width: { wpx: 100 }, style },
                    { title: "เวลาที่ปิดใบงาน", width: { wpx: 100 }, style }
                ], data: []
            }],
            DataSetCategory: [{}],
            DataSetStatus: [{}],
            DataSetProject: [{}],
            jwt: jwt,
            src_project: [],
            src_category: '',
            src_group_type: '',
            src_service_type: '',
            src_service_status: '',
            src_channel: '',
            src_startdate: '',
            src_enddate: '',
            src_member: '',
            src_phonein: '',
            src_sla: '',
            page: 0,
            rowsPerPage: 10,
            colHeaderProj: 1000,
            report_type: 'worksheet',
            isActiveLoading: false,
            colCategory: [],
            rowsCategory: [],
            colStatus: [],
            rowsStatus: [],
            colProject: [],
            rowsProject: [],
            report_title: 'Total Case & Detail Report (รายงานแสดงรายละเอียดแยกตามใบงาน)',
            project_disable: false
        }

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.dataTable = this.dataTable.bind(this);
        this.change = this.change.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.openView = this.openView.bind(this);
        this.openReport = this.openReport.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.clearData = this.clearData.bind(this);
        this.dataReportCategory = this.dataReportCategory.bind(this);
        this.changeReport = this.changeReport.bind(this);
        this.dataReportStatus = this.dataReportStatus.bind(this);
        this.initData = this.initData.bind(this)
        this.project_home()
        this.dataTable()
    }

    project_home() {
        try {
            var body = ``
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            if (this.state.PROJECTID) {
                body = `?projecthomeid=${this.state.PROJECTID}`
                fetch(config.url.API_URL + '/project_homes/' + body, requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        var sortData = data.data.sort(function (a, b) {
                            return a.num - b.num;
                        });
    
                        var found = sortData.filter(function (item) { return item.active; });
                        var found2 = found.filter(function (item) { return !item.delete; });
    
                        var FromApi = found2.map(data => {
                            return { value: data.id, display: data.name_th }
                        });
    
                        this.setState({
                            project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                        });
                    }).catch(error => {
                        console.log(error)
                        // //window.location.reload(); // Reload the page
                    });
            } else {
                fetch(config.url.API_URL + '/project_homes/', requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        var sortData = data.data.sort(function (a, b) {
                            return a.num - b.num;
                        });
    
                        var found = sortData.filter(function (item) { return item.active; });
                        var found2 = found.filter(function (item) { return !item.delete; });
    
                        var FromApi = found2.map(data => {
                            return { value: data.id, display: data.name_th }
                        });
    
                        this.setState({
                            project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                        });
                    }).catch(error => {
                        console.log(error)
                        // //window.location.reload(); // Reload the page
                    });
            }
        } catch (error) {
            console.log(error)
            // //window.location.reload(); // Reload the page
        }
    }

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
        this.initData()
    }

    initData(){
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            if (this.state.category) {
    
                fetch(config.url.API_URL + '/service_types/?categoryid=' + this.state.category + '&sortnameth=1', requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        //alert(data.status);
                        var FromApi = data.data.map(datas => {
                            return { value: datas.id, display: datas.name_th }
                        });
    
                        this.setState({
                            service_type: [{ value: '', display: 'เลือกเรื่องย่อย' }].concat(FromApi)
                        });
    
                    }).catch(error => {
                        console.log(error)
                        // //window.location.reload(); // Reload the page
                    });;
            }
    
            fetch(config.url.API_URL + '/service_categorys/?type=cc', requestOptions)  // cc => แจ้งซ่อม || hc ข้อเสนอแนะทั่วไป
                .then(res => res.json())
                .then(data => {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    //alert(data.status);
                    var FromApi = data.data.map(datas => {
                        return { value: datas.id, display: datas.name_th }
                    });
                    this.setState({
                        service_category: [{ value: '', display: 'เลือกหมวดเรื่อง' }].concat(FromApi)
                    });
    
                }).catch(error => {
                    console.log(error)
                    // //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            // //window.location.reload(); // Reload the page
        }
    }

    dataTable() {
        try {
            var style = {
                border: {
                    top: { style: "thin", color: { rgb: "000000" } }
                    , left: { style: "thin", color: { rgb: "000000" } }
                    , right: { style: "thin", color: { rgb: "000000" } }
                    , bottom: { style: "thin", color: { rgb: "000000" } }
                }
                , font: { name: "Tahoma", sz: "10" }
                , fill: { patternType: "solid", fgColor: { rgb: "FFFFFF" } }
            }
    
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
            var projecttmp = ""
            if (this.state.PROJECTID && this.state.src_project.length == 0) {
                projecttmp = this.state.PROJECTID
            } else {
                for (var i = 0; i < this.state.src_project.length; i++) {
                    if (i == 0) {
                        projecttmp += this.state.src_project[i].value
                    } else {
                        projecttmp += "," + this.state.src_project[i].value
                    }
                }
            }
    
            fetch(config.url.API_URL + '/service_complaints/?phone=' + (this.state.src_phonein ? this.state.src_phonein : '')
                + '&projecthomeid=' + (projecttmp ? projecttmp : '')
                + '&servicetypeid=' + (this.state.src_service_type ? this.state.src_service_type : '')
                + '&categoryid=' + (this.state.src_category ? this.state.src_category : '')
                + '&groupid=' + (this.state.src_group_type ? this.state.src_group_type : '')
                + '&servicestatus=' + (this.state.src_service_status ? this.state.src_service_status : '')
                + '&channel=' + (this.state.src_channel ? this.state.src_channel : '')
                + '&startdate=' + (this.state.src_startdate ? this.state.src_startdate : '')
                + '&enddate=' + (this.state.src_enddate ? this.state.src_enddate : '')
                + '&name=' + (this.state.src_member ? this.state.src_member : '')
                + '&sla=' + (this.state.src_sla ? this.state.src_sla : '')
                + "&bystatus=1"
                , requestOptions)
                .then(res => res.json())
                .then(data => {
                    if (Array.isArray(data.data) && data.data.length) {
                        var FromApi = data.data.map(datas => {
                            if (Array.isArray(datas.detail_list) && datas.detail_list.length) {
                                for (var i = 0; i < datas.detail_list.length; i++) {
                                    const deliveryDate = datas.delivery_date ? moment(datas.delivery_date).format('DD/MM/YYYY')  : 'ไม่พบข้อมูล'
                                    const expiredDate = datas.expired_insurance ? moment(datas.expired_insurance).format('DD/MM/YYYY')  : 'ไม่พบข้อมูล'
                                    return {
                                        number: datas.service_number,
                                        service_date: moment(datas.created).format('DD/MM/YYYY'),
                                        service_time: moment(datas.created).format('H:mm'),
                                        member_name: datas.member_first_name + ' ' + datas.member_last_name,
                                        phone_come: datas.income_phone,
                                        project_name: (datas.project_homes.length > 0 ? datas.project_homes[0].name_th : ""),
                                        home_number: datas.home_number,
                                        project_status: helpers.getProjectStatus(datas.project_status),
                                        category: (datas.service_categorys.length > 0 ? datas.service_categorys[0].name_th : ""),
                                        warranty_date: deliveryDate + ' - ' + expiredDate,
                                        title: (Array.isArray(datas.service_types) && datas.service_types.length ?
                                            datas.service_types[0].name_th : ''),
                                        contact: helpers.getContactChannel(datas.contact_chanel),
                                        service_status: helpers.getServiceStatus(datas.service_status),
                                    }
                                }
                            } else {
                                const deliveryDate = datas.delivery_date ? moment(datas.delivery_date).format('DD/MM/YYYY')  : 'ไม่พบข้อมูล'
                                const expiredDate = datas.expired_insurance ? moment(datas.expired_insurance).format('DD/MM/YYYY')  : 'ไม่พบข้อมูล'
                                return {
                                    number: datas.service_number,
                                    service_date: moment(datas.created).format('DD/MM/YYYY'),
                                    service_time: moment(datas.created).format('H:mm'),
                                    member_name: datas.member_first_name + ' ' + datas.member_last_name,
                                    phone_come: datas.income_phone,
                                    project_name: (datas.project_homes.length > 0 ? datas.project_homes[0].name_th : ""),
                                    home_number: datas.home_number,
                                    project_status: helpers.getProjectStatus(datas.project_status),
                                    category: (datas.service_categorys.length > 0 ? datas.service_categorys[0].name_th : ""),
                                    warranty_date: deliveryDate + ' - ' + expiredDate,
                                    title: (Array.isArray(datas.service_types) && datas.service_types.length ?
                                        datas.service_types[0].name_th : ''),
                                    contact: helpers.getContactChannel(datas.contact_chanel),
                                    service_status: helpers.getServiceStatus(datas.service_status),
                                }
                            }
    
                        });
    
                        var FromExcel = []
                        var datasExcel = data.data;
                        for (var j = 0; j < datasExcel.length; j++) {
                            if (Array.isArray(datasExcel[j].detail_list) && datasExcel[j].detail_list.length > 0 && datasExcel[j].detail_list[0].detail != undefined && datasExcel[j].detail_list[0].detail != "") {
                                for (var i = 0; i < datasExcel[j].detail_list.length; i++) {
                                    let slaRange = `-1`
                                    if(datasExcel[j].detail_list[i].serviceDate && datasExcel[j].detail_list[i].successDate) {
                                        if(moment(datasExcel[j].detail_list[i].successDate).diff(datasExcel[j].detail_list[i].serviceDate, 'hours') >= 24) {
                                            slaRange  = moment(datasExcel[j].detail_list[i].successDate).diff(datasExcel[j].detail_list[i].serviceDate, 'days') + 'วัน'
                                        }else if(moment(datasExcel[j].detail_list[i].successDate).diff(datasExcel[j].detail_list[i].serviceDate, 'hours') < 24 && moment(datasExcel[j].detail_list[i].successDate).diff(datasExcel[j].detail_list[i].serviceDate, 'hours') > 0){
                                            slaRange  = moment(datasExcel[j].detail_list[i].successDate).diff(datasExcel[j].detail_list[i].serviceDate, 'hours') + 'ชั่วโมง'
                                        }else{
                                            slaRange = '1 วัน'
                                        }
                                    }else{
                                        slaRange = (Array.isArray(datasExcel[j].juristic_types) && datasExcel[j].juristic_types.length ? (datasExcel[j].juristic_types[0].sla ? (datasExcel[j].juristic_types[0].sla > 24 ? (datasExcel[j].juristic_types[0].sla / 24) + " วัน" : datasExcel[j].juristic_types[0].sla + " ชั่วโมง") : '-') : '-') + ''
                                    }
    
                                    FromExcel.push([
                                        { value: datasExcel[j].service_number + '', style },
                                        { value: moment(datasExcel[j].created).format('DD/MM/YYYY') + '', style },
                                        { value: moment(datasExcel[j].created).format('H:mm') + '', style },
                                        { value: datasExcel[j].member_first_name + ' ' + datasExcel[j].member_last_name, style },
                                        { value: datasExcel[j].income_phone + '', style },
                                        // { value: (datasExcel[j].member_phone === undefined ? '' : datasExcel[j].member_phone + '') + '', style },
                                        { value: (Array.isArray(datasExcel[j].project_homes) ? datasExcel[j].project_homes[0].name_th : "") + '', style },
                                        { value: datasExcel[j].home_number + '', style },
                                        { value: (datasExcel[j].project_status === undefined ? '-' : helpers.getProjectStatus(datasExcel[j].project_status)) + '', style },
                                        {
                                            value: (datasExcel[j].delivery_date ? moment(datasExcel[j].delivery_date).format('DD/MM/YYYY') : 'ไม่พบข้อมูล')
                                                + ' - ' + (datasExcel[j].expired_insurance ? moment(datasExcel[j].expired_insurance).format('DD/MM/YYYY') : 'ไม่พบข้อมูล'), style
                                        },
                                        { value: (datasExcel[j].express ? 'เร่งด่วน' : ''), style },
                                        { value: (datasExcel[j].service_categorys.length > 0 ? datasExcel[j].service_categorys[0].name_th : "-") + '', style },
                                        {
                                            value: (Array.isArray(datasExcel[j].service_groups) && datasExcel[j].service_groups.length ?
                                                datasExcel[j].service_groups[0].name_th : '') + '', style
                                        },
                                        {
                                            value: (Array.isArray(datasExcel[j].service_types) && datasExcel[j].service_types.length ?
                                                datasExcel[j].service_types[0].name_th : '') + '', style
                                        },
                                        { value: (datasExcel[j].detail === undefined ? '' : datasExcel[j].detail + '') + '', style },
                                        { value: helpers.getServiceStatusText(datasExcel[j].service_status) + '', style },
                                        { value: (datasExcel[j].createby === undefined ? '' : datasExcel[j].createby + ''), style },
                                        {
                                            // 
                                            value: slaRange, style
                                        },
                                        // {
                                        //     // 
                                        //     value: (Array.isArray(datasExcel[j].service_types) && datasExcel[j].service_types.length ?
                                        //         (datasExcel[j].service_types[0].sla ? (datasExcel[j].service_types[0].sla > 24 ? (datasExcel[j].service_types[0].sla / 24) + " วัน" : datasExcel[j].service_types[0].sla + " ชั่วโมง") : '-') : '-') + '', style
                                        // },
                                        { value: helpers.getSla(moment(datasExcel[j].sla_start_date), moment(datasExcel[j].sla_end_date), datasExcel[j].service_status) + '', style },
                                        { value: (datasExcel[j].close_date ? moment(datasExcel[j].close_date).format('DD/MM/YYYY') : '') + '', style },
                                        { value: (datasExcel[j].close_date ? moment(datasExcel[j].close_date).format('H:mm') : '') + '', style },
                                        { value: (datasExcel[j].detail_list[i].service_type_name === undefined ? '' : datasExcel[j].detail_list[i].service_type_name + ''), style },
                                        { value: (datasExcel[j].detail_list[i].detail === undefined ? '' : datasExcel[j].detail_list[i].detail + ''), style },
                                        { value: (datasExcel[j].detail_list[i].subscriber === undefined ? '' : datasExcel[j].detail_list[i].subscriber + ''), style },
                                        { value: (datasExcel[j].detail_list[i].operator === undefined ? '' : datasExcel[j].detail_list[i].operator + ''), style },
                                        { value: (datasExcel[j].detail_list[i].serviceDate ? moment(datasExcel[j].detail_list[i].serviceDate).format('DD/MM/YYYY') + '' : ''), style },
                                        { value: (datasExcel[j].detail_list[i].successDate ? moment(datasExcel[j].detail_list[i].successDate).format('DD/MM/YYYY') + '' : ''), style },
                                        { value: (datasExcel[j].detail_list[i].editDate ? moment(datasExcel[j].detail_list[i].editDate).format('DD/MM/YYYY') + '' : ''), style },
                                        { value: (datasExcel[j].detail_list[i].note === undefined ? '' : datasExcel[j].detail_list[i].note + ''), style },
                                        { value: (datasExcel[j].detail_list[i].serviceStatus === undefined ? '' : helpers.getServiceStatusText(datasExcel[j].detail_list[i].serviceStatus) + ''), style }
                                    ])
                                }
                            } else {
                                FromExcel.push([
                                    { value: datasExcel[j].service_number + '', style },
                                    { value: moment(datasExcel[j].created).format('DD/MM/YYYY') + '', style },
                                    { value: moment(datasExcel[j].created).format('H:mm') + '', style },
                                    { value: datasExcel[j].member_first_name + ' ' + datasExcel[j].member_last_name, style },
                                    { value: datasExcel[j].income_phone + '', style },
                                    // { value: (datasExcel[j].member_phone === undefined ? '' : datasExcel[j].member_phone + '') + '', style },
                                    { value: (Array.isArray(datasExcel[j].project_homes) ? datasExcel[j].project_homes[0].name_th : "") + '', style },
                                    { value: datasExcel[j].home_number + '', style },
                                    { value: (datasExcel[j].project_status === undefined ? '-' : helpers.getProjectStatus(datasExcel[j].project_status)) + '', style },
                                    {
                                        value: (datasExcel[j].delivery_date ? moment(datasExcel[j].delivery_date).format('DD/MM/YYYY') : 'ไม่พบข้อมูล')
                                            + ' - ' + (datasExcel[j].expired_insurance ? moment(datasExcel[j].expired_insurance).format('DD/MM/YYYY') : 'ไม่พบข้อมูล'), style
                                    },
                                    { value: (datasExcel[j].express ? 'เร่งด่วน' : ''), style },
                                    { value: (datasExcel[j].service_categorys.length > 0 ? datasExcel[j].service_categorys[0].name_th : "-") + '', style },
                                    {
                                        value: (Array.isArray(datasExcel[j].service_groups) && datasExcel[j].service_groups.length ?
                                            datasExcel[j].service_groups[0].name_th : '') + '', style
                                    },
                                    {
                                        value: (Array.isArray(datasExcel[j].service_types) && datasExcel[j].service_types.length ?
                                            datasExcel[j].service_types[0].name_th : '') + '', style
                                    },
                                    { value: (datasExcel[j].detail === undefined ? '' : datasExcel[j].detail + '') + '', style },
                                    { value: helpers.getServiceStatusText(datasExcel[j].service_status) + '', style },
                                    { value: (datasExcel[j].createby === undefined ? '' : datasExcel[j].createby + ''), style },
                                    {
                                        value: (Array.isArray(datasExcel[j].service_types) && datasExcel[j].service_types.length ?
                                            (datasExcel[j].service_types[0].sla ? (datasExcel[j].service_types[0].sla > 24 ? (datasExcel[j].service_types[0].sla / 24) + " วัน" : datasExcel[j].service_types[0].sla + " ชั่วโมง") : '-') : '-') + '', style
                                    },
                                    { value: helpers.getSla(moment(datasExcel[j].sla_start_date), moment(datasExcel[j].sla_end_date), datasExcel[j].service_status) + '', style },
                                    { value: (datasExcel[j].close_date ? moment(datasExcel[j].close_date).format('DD/MM/YYYY') : '') + '', style },
                                    { value: (datasExcel[j].close_date ? moment(datasExcel[j].close_date).format('H:mm') : '') + '', style },
                                    { value: '', style },
                                    { value: '', style },
                                    { value: '', style },
                                    { value: '', style },
                                    { value: '', style },
                                    { value: '', style },
                                    { value: '', style },
                                    { value: '', style },
                                    { value: '', style }
                                ])
                            }
                        }
    
                        style = {
                            border: {
                                top: { style: "thin", color: { rgb: "000000" } }
                                , left: { style: "thin", color: { rgb: "000000" } }
                                , right: { style: "thin", color: { rgb: "000000" } }
                                , bottom: { style: "thin", color: { rgb: "000000" } }
                            }
                            , font: { name: "Tahoma", sz: "10" }
                            , fill: { patternType: "solid", fgColor: { rgb: "E8EFF5" } }
                        }
    
                        this.setState({
                            pages: [].concat(FromApi),
                            dataReport: [{
                                columns: [
                                    { title: "เลขที่", width: { wpx: 100 }, style },
                                    { title: "วันที่รับเรื่อง", width: { wpx: 150 }, style },
                                    { title: "เวลา", width: { wpx: 100 }, style },
                                    { title: "ผู้แจ้ง", width: { wpx: 150 }, style },
                                    { title: "เบอร์โทรเข้า", width: { wpx: 150 }, style },
                                    // { title: "เบอร์โทรติดต่อ", width: { wpx: 150 }, style },
                                    { title: "โครงการ", width: { wpx: 300 }, style },
                                    { title: "บ้านเลขที่", width: { wpx: 100 }, style },
                                    { title: "สถานะ", width: { wpx: 100 }, style },
                                    { title: "ระยะเวลาประกัน", width: { wpx: 200 }, style },
                                    { title: "เร่งด่วน", width: { wpx: 80 }, style },
                                    { title: "หมวดเรื่อง", width: { wpx: 200 }, style },
                                    { title: "กลุ่มหัวข้อ", width: { wpx: 200 }, style },
                                    { title: "เรื่องย่อย", width: { wpx: 200 }, style },
                                    { title: "รายละเอียด", width: { wpx: 300 }, style },
                                    { title: "สถานะใบงาน", width: { wpx: 150 }, style },
                                    { title: "Agent", width: { wpx: 150 }, style },
                                    { title: "SLA เรื่องย่อย", width: { wpx: 100 }, style },
                                    { title: "SLA Case", width: { wpx: 100 }, style },
                                    { title: "วันที่ปิดใบงาน", width: { wpx: 100 }, style },
                                    { title: "เวลาที่ปิดใบงาน", width: { wpx: 100 }, style },
                                    { title: "รายการย่อย", width: { wpx: 300 }, style },
                                    { title: "รายการซ่อม", width: { wpx: 300 }, style },
                                    { title: "ผู้เซ็นต์รับ", width: { wpx: 150 }, style },
                                    { title: "ผู้ดำเนินการ", width: { wpx: 150 }, style },
                                    { title: "วันที่ช่างเข้า", width: { wpx: 150 }, style },
                                    { title: "วันที่แล้วเสร็จ", width: { wpx: 150 }, style },
                                    { title: "วันที่แก้ไขเพิ่มเติม", width: { wpx: 150 }, style },
                                    { title: "หมายเหตุ", width: { wpx: 150 }, style },
                                    { title: "สถานะการซ่อม", width: { wpx: 150 }, style }
                                ], data: [].concat(FromExcel)
                            }]
                        });
                        console.log("**************************************")
                        // console.log(JSON.stringify(this.state.dataReport))
                        console.log(`FromExcel`)
                        console.log(FromExcel)
                        console.log("**************************************")
    
                    } else {
                        this.setState({
                            pages: []
                        });
                    }
    
                }).catch(error => {
                    console.log(error)
                    // //window.location.reload(); // Reload the page
                });
            return this.state.DataSetWorkSheet;
        } catch (error) {
            console.log(error)
            // //window.location.reload(); // Reload the page
        }
    }

    changeStartDate = date => {
        this.setState({
            src_startdate: date
        });
    }

    changeEndDate = date => {
        this.setState({
            src_enddate: date
        });
    }

    change(e) {
        try {
            this.setState({
                [e.target.name]: e.target.value
            });
    
            if (e.target.name == "src_category") {
                console.log(`src_category`)
                console.log(e.target.value)
        
                if(e.target.value){
                    const requestOptions = {
                        method: 'GET',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': this.state.jwt,
                        },
                    };
        
                    fetch(config.url.API_URL + '/service_groups/?categoryid=' + e.target.value + '&sortnameth=1', requestOptions)
                        .then(res => res.json())
                        .then(data => {
                            // store user details and jwt token in local storage to keep user logged in between page refreshes
                            //alert(data.status);
                            if (data.data != undefined) {
                                var FromApi = data.data.map(datas => {
                                    return { value: datas.id, display: datas.name_th }
                                });
        
                                this.setState({
                                    group_type: [{ value: '', display: 'เลือกกลุ่มหัวข้อ' }].concat(FromApi)
                                });
                            }
                        }).catch(error => {
                            console.log(error)
                            //window.location.reload(); // Reload the page
                        });
                }else{
                    this.setState({
                        group_type: [{ value: '', display: 'เลือกกลุ่มหัวข้อ' }],
                        service_type: [{ value: '', display: 'เลือกกลุ่มหัวข้อ' }],
                        src_category: '',
                        src_group_type: '',
                        src_service_type: ''
                    });
                }
            } 
            
            if (e.target.name == "src_group_type") {
                if (e.target.value) {
    
                    const requestOptions = {
                        method: 'GET',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': this.state.jwt,
                        },
                    };
    
                    fetch(config.url.API_URL + '/service_types/?categoryid=' + this.state.src_category + '&servicegroupid=' + e.target.value + '&sortnameth=1', requestOptions)
                        .then(res => res.json())
                        .then(data => {
                            // store user details and jwt token in local storage to keep user logged in between page refreshes
                            //alert(data.status);
                            var FromApi = data.data.map(datas => {
                                return { value: datas.id, display: datas.name_th }
                            });
                            this.setState({
                                service_type: [{ value: '', display: 'เลือกเรื่องย่อย' }].concat(FromApi)
                            });
                        }).catch(error => {
                            console.log(error)
                            //window.location.reload(); // Reload the page
                        });
                } else {
                    this.setState({
                        service_type: [{ value: '', display: 'เลือกเรื่องย่อย' }],
                        src_group_type: "",
                        src_service_type: ""
                    });
                }
            }
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    handleSubmit(e) {
        e.preventDefault();
    }

    async openView() {
        //report_type
        this.setState({
            pages: [],
            page: 0,
            rowsPerPage: 10,
            isActiveLoading: true
        });

        if (this.state.report_type == "worksheet") {
            this.dataTable();
        } else if (this.state.report_type == "category") {
            if (this.state.src_startdate || this.state.src_enddate) {
                //this.dataTable();
                this.setState({
                    dataReport: await this.dataReportCategory(this.state.service_category)
                })
            } else {
                alert("ไม่พบวันที่เริ่มต้นและสิ้นสุด");
            }
        } else if (this.state.report_type == "status") {
            //this.dataTable();
            this.setState({
                dataReport: await this.dataReportStatus(this.state.project_home)
            })

        } else if (this.state.report_type == "project") {
            //this.dataTable();
            this.setState({
                dataReport: await this.dataReportProject(this.state.service_category, this.state.project_home)
            })

        }

        console.log("*****************%%%%%%%*********************")
        console.log(JSON.stringify(this.state.rowsCategory))
        console.log("*****************%%%%%%%*********************")
        this.setState({
            isActiveLoading: false
        });
    }

    openReport(e) {
        //window.location.href = "/reportexcel";
    }

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    clearData(e) {
        this.setState({
            src_project: [],
            src_category: '',
            src_service_type: '',
            src_service_status: '',
            src_group_type: '',
            src_channel: '',
            src_startdate: '',
            src_enddate: '',
            src_member: '',
            src_phonein: '',
            src_sla: '',
            pages: []
        });
        document.getElementById("form-submit").reset();
        this.changeReport({target:{value: 'worksheet', name: 'report_type'}})
    }

    async dataReportProject(cat, proj) {
        var category = []
        var net = 0
        var dataNet = []

        var startdate = (this.state.src_startdate ? this.state.src_startdate : '');
        var enddate = (this.state.src_enddate ? this.state.src_enddate : '');
        var style = {
            border: {
                top: { style: "thin", color: { rgb: "000000" } }
                , left: { style: "thin", color: { rgb: "000000" } }
                , right: { style: "thin", color: { rgb: "000000" } }
                , bottom: { style: "thin", color: { rgb: "000000" } }
            }
            , font: { name: "Tahoma", sz: "10", color: "4796C8" }
            , fill: { patternType: "solid", fgColor: { rgb: "EEEEEE" } }
        }

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        for (var i = 0; i < cat.length; i++) {
            if (cat[i].value) {
                style = {
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } }
                        , left: { style: "thin", color: { rgb: "000000" } }
                        , right: { style: "thin", color: { rgb: "000000" } }
                        , bottom: { style: "thin", color: { rgb: "000000" } }
                    }
                    , font: { name: "Tahoma", sz: "10", color: "4796C8" }, alignment: { horizontal: "center" }
                    , fill: { patternType: "solid", fgColor: { rgb: "EEEEEE" } }
                }
                var catValue = [{ value: cat[i].display, style }, { value: 0, style }]

                for (var a = 0; a < proj.length; a++) {
                    if (proj[a].value) {
                        catValue.push({ value: 0, style })
                    }
                }
                //group start
                await fetch(config.url.API_URL + '/service_groups/?categoryid=' + cat[i].value + '&sortnameth=1', requestOptions)
                    .then(res => res.json())
                    .then(async GroupData => {
                        var datasGroup = await GroupData.data
                        var FromApi = []
                        for (var g = 0; g < datasGroup.length; g++) {
                            var FromGroup = []
                            var totalGroup = 0;
                            style = {
                                border: {
                                    top: { style: "thin", color: { rgb: "000000" } }
                                    , left: { style: "thin", color: { rgb: "000000" } }
                                    , right: { style: "thin", color: { rgb: "000000" } }
                                    , bottom: { style: "thin", color: { rgb: "000000" } }
                                }
                                , font: { name: "Tahoma", sz: "10" }, alignment: { horizontal: "center" }, fill: { patternType: "solid", fgColor: { rgb: "EEEEEE" } }
                            }
                            var groupValue = [{ value: datasGroup[g].name_th, style }, { value: 0, style }];

                            for (var a = 0; a < proj.length; a++) {
                                if (proj[a].value) {
                                    groupValue.push({ value: 0, style })
                                }
                            }

                            await fetch(config.url.API_URL + '/service_types/?categoryid=' + cat[i].value + '&servicegroupid=' + datasGroup[g].id + '&sortnameth=1', requestOptions)
                                .then(res => res.json())
                                .then(async data => {
                                    //FromApi = FromApi.concat([catValue])
                                    style = {
                                        border: {
                                            top: { style: "thin", color: { rgb: "000000" } }
                                            , left: { style: "thin", color: { rgb: "000000" } }
                                            , right: { style: "thin", color: { rgb: "000000" } }
                                            , bottom: { style: "thin", color: { rgb: "000000" } }
                                        }, font: { name: "Tahoma", sz: "10" }, alignment: { horizontal: "center" }, fill: { patternType: "solid", fgColor: { rgb: "FFFFFF" } }
                                    }
                                    var datas = await data.data

                                    if (datas.length > 0) {
                                        for (var j = 0; j < datas.length; j++) {
                                            //console.log("*****************start FromApi*********************")
                                            var value = []
                                            var total = 0;

                                            await fetch(config.url.API_URL + '/reportproject/?service_type_id=' + datas[j].id
                                                + '&sla=' + (this.state.src_sla ? this.state.src_sla : '')
                                                + '&startdate=' + startdate
                                                + '&enddate=' + enddate, requestOptions)
                                                .then(res => res.json())
                                                .then(data => {
                                                    var datasReport = data.data
                                                    var i2 = 0
                                                    for (var a = 0; a < proj.length; a++) {
                                                        if (proj[a].value) {
                                                            const result = datasReport.find(({ _id }) => _id[0] === proj[a].display);
                                                            var resultCount = 0
                                                            if (result === undefined) {
                                                                value.push({ value: 0, style })
                                                            } else {
                                                                resultCount = result.count
                                                                total += result.count

                                                                catValue[i2 + 1].value = (parseInt(catValue[i2 + 1].value) + parseInt(result.count))
                                                                catValue[1].value = (parseInt(catValue[1].value) + parseInt(result.count))

                                                                groupValue[i2 + 1].value = (parseInt(groupValue[i2 + 1].value) + parseInt(result.count))
                                                                groupValue[1].value = (parseInt(groupValue[1].value) + parseInt(result.count))

                                                                value.push({ value: result.count, style })

                                                            }

                                                            if (dataNet[i2 - 1] === undefined) {
                                                                dataNet.push(resultCount)
                                                            } else {
                                                                dataNet[i2 - 1] = (parseInt(dataNet[i2 - 1]) + resultCount)
                                                            }

                                                        }

                                                        i2 += 1
                                                    }

                                                    net += total
                                                }).catch(error => {
                                                    console.log(error)
                                                    //window.location.reload(); // Reload the page
                                                });
                                            value.unshift({ value: total, style })
                                            value.unshift({
                                                value: datas[j].name_th, style: {
                                                    border: {
                                                        top: { style: "thin", color: { rgb: "000000" } }
                                                        , left: { style: "thin", color: { rgb: "000000" } }
                                                        , right: { style: "thin", color: { rgb: "000000" } }
                                                        , bottom: { style: "thin", color: { rgb: "000000" } }
                                                    }
                                                    , font: { name: "Tahoma", sz: "10" }, fill: { patternType: "solid", fgColor: { rgb: "FFFFFF" } }
                                                }
                                            })
                                            FromGroup = FromGroup.concat([value])

                                        }
                                        FromGroup.unshift(groupValue)
                                        FromApi = FromApi.concat(FromGroup)
                                    }
                                }).catch(error => {
                                    console.log(error)
                                    //window.location.reload(); // Reload the page
                                });
                        }//end for loop group
                        FromApi.unshift(catValue)
                        category = category.concat(FromApi)
                    }).catch(error => {
                        console.log(error)
                        //window.location.reload(); // Reload the page
                    }); //end group
            }
        }

        style = {
            border: {
                top: { style: "thin", color: { rgb: "000000" } }
                , left: { style: "thin", color: { rgb: "000000" } }
                , right: { style: "thin", color: { rgb: "000000" } }
                , bottom: { style: "thin", color: { rgb: "000000" } }
            }
            , font: { name: "Tahoma", sz: "10" }, alignment: { horizontal: "center" }
            , fill: { patternType: "solid", fgColor: { rgb: "E8EFF5" } }
        }
        var col = [{ title: "Category", width: { wpx: 300 }, style }, { title: "รวม", width: { wpx: 100 }, style }]
        let colSum = 400
        for (var a = 0; a < proj.length; a++) {
            if (proj[a].value) {
                col = col.concat({ title: proj[a].display, width: { wpx: 120 }, style })
                colSum += 120
            }
        }

        //console.log("*****************col*********************"+JSON.stringify(col))
        style = {
            border: {
                top: { style: "thin", color: { rgb: "000000" } }
                , left: { style: "thin", color: { rgb: "000000" } }
                , right: { style: "thin", color: { rgb: "000000" } }
                , bottom: { style: "thin", color: { rgb: "000000" } }
            }
            , font: { name: "Tahoma", sz: "12", bold: true }
            , fill: {
                patternType: "solid"
                , fgColor: { rgb: "FFFFFF" }
            }
        }

        var col_title = [{ title: "Category Summary by Project Report (รายงานสรุปจำนวนใบงานแยกตามโครงการ)", width: { wpx: 300 }, style }]
        
        style = {
            border: {
                top: { style: "thin", color: { rgb: "000000" } }
                , left: { style: "thin", color: { rgb: "000000" } }
                , right: { style: "thin", color: { rgb: "000000" } }
                , bottom: { style: "thin", color: { rgb: "000000" } }
            }
            , font: { name: "Tahoma", sz: "10" }
            , fill: {
                patternType: "solid"
                , fgColor: { rgb: "FFFFFF" }
            }
        }

        var col_date = [{ title: "วันที่ : " + moment(startdate).format('DD/MM/YYYY') + " - " + moment(enddate).format('DD/MM/YYYY'), width: { wpx: 300 }, style }]

        var col_net = [{
            value: "รวมทั้งหมด", style: {
                border: {
                    top: { style: "thin", color: { rgb: "000000" } }
                    , left: { style: "thin", color: { rgb: "000000" } }
                    , right: { style: "thin", color: { rgb: "000000" } }
                    , bottom: { style: "thin", color: { rgb: "000000" } }
                }
                , font: { name: "Tahoma", sz: "12", color: "4796C8" }
                , alignment: { horizontal: "right" }
                , fill: {
                    patternType: "solid"
                    , fgColor: { rgb: "FFFFFF" }
                }
            }
        }, {
            value: net, style: {
                border: {
                    top: { style: "thin", color: { rgb: "000000" } }
                    , left: { style: "thin", color: { rgb: "000000" } }
                    , right: { style: "thin", color: { rgb: "000000" } }
                    , bottom: { style: "thin", color: { rgb: "000000" } }
                }
                , font: { name: "Tahoma", sz: "12", color: "4796C8" }
                , alignment: { horizontal: "center" }
                , fill: {
                    patternType: "solid"
                    , fgColor: { rgb: "FFFFFF" }
                }
            }
        }]

        for (var i = 0; i < dataNet.length; i++) {
            col_net.push({
                value: dataNet[i], style: {
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } }
                        , left: { style: "thin", color: { rgb: "000000" } }
                        , right: { style: "thin", color: { rgb: "000000" } }
                        , bottom: { style: "thin", color: { rgb: "000000" } }
                    }
                    , font: { name: "Tahoma", sz: "12", color: "4796C8" }
                    , alignment: { horizontal: "center" }
                    , fill: {
                        patternType: "solid"
                        , fgColor: { rgb: "FFFFFF" }
                    }
                }
            })
        }

        category.unshift(col_net)

        this.setState({
            colHeaderProj: colSum,
            DataSetProject: [{
                columns: col_title
                , data: []
            }, {
                columns: col_date
                , data: []
            }, {
                columns: col
                , data: category
            }],
            colProject: col,
            rowsProject: category
        });

        //console.log("*****************API dataReportProject*********************"+JSON.stringify(this.state.DataSetProject))
        return this.state.DataSetProject;
    }

    async dataReportStatus(proj) {
        var project = []
        var net = 0
        var dataNet = []
        var style = {
            border: {
                top: { style: "thin", color: { rgb: "000000" } }
                , left: { style: "thin", color: { rgb: "000000" } }
                , right: { style: "thin", color: { rgb: "000000" } }
                , bottom: { style: "thin", color: { rgb: "000000" } }
            }
            , font: { name: "Tahoma", sz: "10" }, alignment: { horizontal: "center" }
            , fill: { patternType: "solid", bgColor: { rgb: "FFFFFF" } }
        }
        var startdate = (this.state.src_startdate ? this.state.src_startdate : '');
        var enddate = (this.state.src_enddate ? this.state.src_enddate : '');
        var sla = (this.state.src_sla ? this.state.src_sla : '');
        var status = [
            { value: "progress" }
            , { value: "doing" }
            // , { value: "coordinated" }
            , { value: "cancel" }
            , { value: "close" }
        ]

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        style = {
            border: {
                top: { style: "thin", color: { rgb: "000000" } }
                , left: { style: "thin", color: { rgb: "000000" } }
                , right: { style: "thin", color: { rgb: "000000" } }
                , bottom: { style: "thin", color: { rgb: "000000" } }
            }
            , font: { name: "Tahoma", sz: "10" }, alignment: { horizontal: "center" }, fill: { patternType: "solid", fgColor: { rgb: "FFFFFF" } }
        }
        for (var i = 0; i < proj.length; i++) {
            //console.log("*****************dataReportStatus>>proj>>value*********************"+proj[i].value)
            if (proj[i].value) {
                //console.log("*****************dataReportStatus>>proj>>display*********************"+proj[i].display)
                var value = []
                var total = 0;
                await fetch(config.url.API_URL + '/reportstatus/?project_home_id=' + proj[i].value
                    + '&startdate=' + startdate
                    + '&enddate=' + enddate
                    + '&sla=' + sla,
                    requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        var datas = data.data
                        console.log(`data in data`)
                        console.log(datas)
                        for (var j = 0; j < status.length; j++) {
                            //console.log("==============status[j].value============"+ JSON.stringify(status[j]))
                            //console.log("==============_id============"+ JSON.stringify(datas))
                            console.log(datas)
                            const result = datas.find(({ _id }) => _id === status[j].value);
                            var resultCount = 0
                            if (result === undefined) {
                                value.push({ value: " ", style })
                            } else {
                                resultCount = result.count
                                total += result.count
                                value.push({ value: result.count, style })
                            }

                            if (dataNet[j] === undefined) {
                                dataNet.push(resultCount)
                            } else {
                                dataNet[j] = (parseInt(dataNet[j]) + resultCount)
                            }

                        }
                        net += total
                    }).catch(error => {
                        console.log(error)
                        //window.location.reload(); // Reload the page
                    });
                console.log("*****************API reportstatus*********************" + JSON.stringify(value))
                value.unshift({ value: total, style })
                value.unshift({
                    value: proj[i].display, style: {
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } }
                            , left: { style: "thin", color: { rgb: "000000" } }
                            , right: { style: "thin", color: { rgb: "000000" } }
                            , bottom: { style: "thin", color: { rgb: "000000" } }
                        }
                        , font: { name: "Tahoma", sz: "10" }, fill: { patternType: "solid", fgColor: { rgb: "FFFFFF" } }
                    }
                })
                project = project.concat([value])

            }
        }

        style = {
            border: {
                top: { style: "thin", color: { rgb: "000000" } }
                , left: { style: "thin", color: { rgb: "000000" } }
                , right: { style: "thin", color: { rgb: "000000" } }
                , bottom: { style: "thin", color: { rgb: "000000" } }
            }
            , font: { name: "Tahoma", sz: "10" }, alignment: { horizontal: "center" }
            , fill: { patternType: "solid", fgColor: { rgb: "E8EFF5" } }
        }

        var col = [
            { title: "ชื่อโครงการ", width: { wpx: 300 }, style },
            { title: "รวม", width: { wpx: 100 }, style },
            { title: "รับเรื่อง", width: { wpx: 150 }, style },
            { title: "กำลังดำเนินการ", width: { wpx: 150 }, style },
            // { title: "ประสานงานแล้ว", width: { wpx: 150 }, style },
            { title: "ยกเลิก", width: { wpx: 150 }, style },
            { title: "จบงาน", width: { wpx: 150 }, style }
        ]

        style = {
            border: {
                top: { style: "thin", color: { rgb: "000000" } }
                , left: { style: "thin", color: { rgb: "000000" } }
                , right: { style: "thin", color: { rgb: "000000" } }
                , bottom: { style: "thin", color: { rgb: "000000" } }
            }
            , font: { name: "Tahoma", sz: "12", bold: true }
            , fill: {
                patternType: "solid"
                , fgColor: { rgb: "FFFFFF" }
            }
        }

        var col_title = [{ title: "Status Case Summary Report (รายงานสรุปจำนวนใบงานแยกตามสถานะ)", width: { wpx: 300 }, style }]

        style = {
            border: {
                top: { style: "thin", color: { rgb: "000000" } }
                , left: { style: "thin", color: { rgb: "000000" } }
                , right: { style: "thin", color: { rgb: "000000" } }
                , bottom: { style: "thin", color: { rgb: "000000" } }
            }
            , font: { name: "Tahoma", sz: "10" }
            , fill: {
                patternType: "solid"
                , fgColor: { rgb: "FFFFFF" }
            }
        }

        var col_date = [{ title: "วันที่ : " + moment(startdate).format('DD/MM/YYYY') + " - " + moment(enddate).format('DD/MM/YYYY'), width: { wpx: 300 }, style }]

        var col_net = [{
            value: "รวมทั้งหมด ", style: {
                border: {
                    top: { style: "thin", color: { rgb: "000000" } }
                    , left: { style: "thin", color: { rgb: "000000" } }
                    , right: { style: "thin", color: { rgb: "000000" } }
                    , bottom: { style: "thin", color: { rgb: "000000" } }
                }
                , font: { name: "Tahoma", sz: "12", color: "4796C8" }
                , alignment: { horizontal: "right" }
                , fill: {
                    patternType: "solid"
                    , fgColor: { rgb: "FFFFFF" }
                }
            }
        }, {
            value: net, style: {
                border: {
                    top: { style: "thin", color: { rgb: "000000" } }
                    , left: { style: "thin", color: { rgb: "000000" } }
                    , right: { style: "thin", color: { rgb: "000000" } }
                    , bottom: { style: "thin", color: { rgb: "000000" } }
                }
                , font: { name: "Tahoma", sz: "12", color: "4796C8" }
                , alignment: { horizontal: "center" }
                , fill: {
                    patternType: "solid"
                    , fgColor: { rgb: "FFFFFF" }
                }
            }
        }]

        for (var i = 0; i < dataNet.length; i++) {
            col_net.push({
                value: dataNet[i], style: {
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } }
                        , left: { style: "thin", color: { rgb: "000000" } }
                        , right: { style: "thin", color: { rgb: "000000" } }
                        , bottom: { style: "thin", color: { rgb: "000000" } }
                    }
                    , font: { name: "Tahoma", sz: "12", color: "4796C8" }
                    , alignment: { horizontal: "center" }
                    , fill: {
                        patternType: "solid"
                        , fgColor: { rgb: "FFFFFF" }
                    }
                }
            })
        }

        project.unshift(col_net)

        this.setState({
            DataSetStatus: [{
                columns: col_title
                , data: []
            }, {
                columns: col_date
                , data: []
            },
            {
                columns: col
                , data: project
            }],
            colStatus: col,
            rowsStatus: project
        });

        return this.state.DataSetStatus;
    }

    async dataReportCategory(cat) {
        console.log(`datareport category`)
        //this.state.DataSetCategory
        if (this.state.src_startdate || this.state.src_enddate) {
            var category = []
            var startdate = (this.state.src_startdate ? this.state.src_startdate : new Date());
            var enddate = (this.state.src_enddate ? this.state.src_enddate : new Date());
            var loopenddate = moment(enddate).add(1, 'days')

            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
            var net = 0;
            var dataNet = [];
            for (var i = 0; i < cat.length; i++) {
                if (cat[i].value) {
                    var style = {
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } }
                            , left: { style: "thin", color: { rgb: "000000" } }
                            , right: { style: "thin", color: { rgb: "000000" } }
                            , bottom: { style: "thin", color: { rgb: "000000" } }
                        }
                        , font: { name: "Tahoma", sz: "10", color: "4796C8" }, alignment: { horizontal: "center" }
                        , fill: { patternType: "solid", fgColor: { rgb: "EEEEEE" } }
                    }
                    var catValue = [{ value: cat[i].display, style }, { value: 0, style }]

                    for (var a = moment(startdate); a.isBefore(loopenddate); a.add(1, 'days')) {
                        catValue.push({ value: 0, style })
                    }

                    //group start

                    await fetch(config.url.API_URL + '/service_groups/?categoryid=' + cat[i].value + '&sortnameth=1', requestOptions)
                        .then(res => res.json())
                        .then(async GroupData => {
                            var datasGroup = await GroupData.data
                            var FromApi = []
                            for (var g = 0; g < datasGroup.length; g++) {
                                var FromGroup = []
                                var totalGroup = 0;
                                style = {
                                    border: {
                                        top: { style: "thin", color: { rgb: "000000" } }
                                        , left: { style: "thin", color: { rgb: "000000" } }
                                        , right: { style: "thin", color: { rgb: "000000" } }
                                        , bottom: { style: "thin", color: { rgb: "000000" } }
                                    }
                                    , font: { name: "Tahoma", sz: "10" }, alignment: { horizontal: "center" }, fill: { patternType: "solid", fgColor: { rgb: "EEEEEE" } }
                                }
                                var groupValue = [{ value: datasGroup[g].name_th, style }, { value: 0, style }];

                                for (var a = moment(startdate); a.isBefore(loopenddate); a.add(1, 'days')) {
                                    groupValue.push({ value: 0, style })
                                }
                                style = {
                                    border: {
                                        top: { style: "thin", color: { rgb: "000000" } }
                                        , left: { style: "thin", color: { rgb: "000000" } }
                                        , right: { style: "thin", color: { rgb: "000000" } }
                                        , bottom: { style: "thin", color: { rgb: "000000" } }
                                    }
                                    , font: { name: "Tahoma", sz: "10" }, alignment: { horizontal: "center" }, fill: { patternType: "solid", fgColor: { rgb: "FFFFFF" } }
                                }
                                await fetch(config.url.API_URL + '/service_types/?categoryid=' + cat[i].value + '&servicegroupid=' + datasGroup[g].id + '&sortnameth=1', requestOptions)
                                    .then(res => res.json())
                                    .then(async data => {
                                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                                        //alert(data.status);
                                        //FromApi = FromApi.concat([catValue])

                                        var datas = await data.data
                                        for (var j = 0; j < datas.length; j++) {
                                            //console.log("*****************start FromApi*********************")
                                            var value = []
                                            //คำนวนแต่ละวัน เพื่อหา sum จำนวนวรายการของแต่ละวัน
                                            var total = 0;

                                            await fetch(config.url.API_URL + '/reportcategory/?service_type_id=' + datas[j].id
                                                + '&sla=' + (this.state.src_sla ? this.state.src_sla : '')
                                                + '&startdate=' + startdate
                                                + '&enddate=' + enddate, requestOptions)
                                                .then(res => res.json())
                                                .then(data => {
                                                    var i2 = 0
                                                    for (var i = moment(startdate); i.isBefore(loopenddate); i.add(1, 'days')) {
                                                        //console.log("==============77777============"+ moment(i).format('YYYY-MM-DD'))
                                                        //console.log("==============9999============"+ JSON.stringify(data.data))
                                                        const result = data.data.find(({ _id }) => _id === moment(i).format('YYYY-MM-DD'));
                                                        //console.log("==============9999============"+ JSON.stringify(result))
                                                        var resultCount = 0
                                                        if (result === undefined) {
                                                            value.push({ value: 0, style })
                                                        } else {
                                                            resultCount = result.count
                                                            total += result.count

                                                            catValue[i2 + 2].value = (parseInt(catValue[i2 + 2].value) + parseInt(result.count))
                                                            catValue[1].value = (parseInt(catValue[1].value) + parseInt(result.count))

                                                            groupValue[i2 + 2].value = (parseInt(groupValue[i2 + 2].value) + parseInt(result.count))
                                                            groupValue[1].value = (parseInt(groupValue[1].value) + parseInt(result.count))

                                                            value.push({ value: result.count, style })
                                                        }

                                                        if (dataNet[i2] === undefined) {
                                                            dataNet.push(resultCount)
                                                        } else {
                                                            dataNet[i2] = (parseInt(dataNet[i2]) + resultCount)
                                                        }

                                                        i2 += 1
                                                    }
                                                    net += total
                                                }).catch(error => {
                                                    console.log(error)
                                                    //window.location.reload(); // Reload the page
                                                });

                                            value.unshift({ value: total, style })
                                            value.unshift({
                                                value: datas[j].name_th, style: {
                                                    border: {
                                                        top: { style: "thin", color: { rgb: "000000" } }
                                                        , left: { style: "thin", color: { rgb: "000000" } }
                                                        , right: { style: "thin", color: { rgb: "000000" } }
                                                        , bottom: { style: "thin", color: { rgb: "000000" } }
                                                    }
                                                    , font: { name: "Tahoma", sz: "10" }, fill: { patternType: "solid", fgColor: { rgb: "FFFFFF" } }
                                                }
                                            })

                                            FromGroup = FromGroup.concat([value])

                                        }
                                        FromGroup.unshift(groupValue)
                                        FromApi = FromApi.concat(FromGroup)
                                    }).catch(error => {
                                        console.log(error)
                                        //window.location.reload(); // Reload the page
                                    });
                            }//end for loop group
                            FromApi.unshift(catValue)
                            category = category.concat(FromApi)
                        }).catch(error => {
                            console.log(error)
                            //window.location.reload(); // Reload the page
                        });//end group

                }

            }

            style = {
                border: {
                    top: { style: "thin", color: { rgb: "000000" } }
                    , left: { style: "thin", color: { rgb: "000000" } }
                    , right: { style: "thin", color: { rgb: "000000" } }
                    , bottom: { style: "thin", color: { rgb: "000000" } }
                }
                , font: { name: "Tahoma", sz: "10" }, alignment: { horizontal: "center" }
                , fill: {
                    patternType: "solid"
                    , fgColor: { rgb: "E8EFF5" }
                }
            }

            var col = [{ title: "Category", width: { wpx: 300 }, style }, { title: "รวม", width: { wpx: 90 }, style }]

            for (var i = moment(startdate); i.isBefore(loopenddate); i.add(1, 'days')) {
                col = col.concat({ title: moment(i).format('DD-MMM-YYYY'), width: { wpx: 90 }, style })
            }

            style = {
                border: {
                    top: { style: "thin", color: { rgb: "000000" } }
                    , left: { style: "thin", color: { rgb: "000000" } }
                    , right: { style: "thin", color: { rgb: "000000" } }
                    , bottom: { style: "thin", color: { rgb: "000000" } }
                }
                , font: { name: "Tahoma", sz: "12", bold: true }
                , fill: {
                    patternType: "solid"
                    , fgColor: { rgb: "FFFFFF" }
                }
            }

            var col_title = [{ title: "Category Summary Report (รายงานสรุปจำนวนใบงานแยกตามหมวดเรื่อง)", width: { wpx: 300 }, style }]

            style = {
                border: {
                    top: { style: "thin", color: { rgb: "000000" } }
                    , left: { style: "thin", color: { rgb: "000000" } }
                    , right: { style: "thin", color: { rgb: "000000" } }
                    , bottom: { style: "thin", color: { rgb: "000000" } }
                }
                , font: { name: "Tahoma", sz: "10" }
                , fill: {
                    patternType: "solid"
                    , fgColor: { rgb: "FFFFFF" }
                }
            }

            var col_date = [{ title: "วันที่ : " + moment(startdate).format('DD/MM/YYYY') + " - " + moment(enddate).format('DD/MM/YYYY'), width: { wpx: 300 }, style }]

            var col_net = [{
                value: "รวมทั้งหมด ", style: {
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } }
                        , left: { style: "thin", color: { rgb: "000000" } }
                        , right: { style: "thin", color: { rgb: "000000" } }
                        , bottom: { style: "thin", color: { rgb: "000000" } }
                    }
                    , font: { name: "Tahoma", sz: "12", color: "4796C8" }
                    , alignment: { horizontal: "right" }
                    , fill: {
                        patternType: "solid"
                        , fgColor: { rgb: "FFFFFF" }
                    }
                }
            }, {
                value: net, style: {
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } }
                        , left: { style: "thin", color: { rgb: "000000" } }
                        , right: { style: "thin", color: { rgb: "000000" } }
                        , bottom: { style: "thin", color: { rgb: "000000" } }
                    }
                    , font: { name: "Tahoma", sz: "12", color: "4796C8" }
                    , alignment: { horizontal: "center" }
                    , fill: {
                        patternType: "solid"
                        , fgColor: { rgb: "FFFFFF" }
                    }
                }
            }]

            for (var i = 0; i < dataNet.length; i++) {
                col_net.push({
                    value: dataNet[i], style: {
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } }
                            , left: { style: "thin", color: { rgb: "000000" } }
                            , right: { style: "thin", color: { rgb: "000000" } }
                            , bottom: { style: "thin", color: { rgb: "000000" } }
                        }
                        , font: { name: "Tahoma", sz: "12", color: "4796C8" }
                        , alignment: { horizontal: "center" }
                        , fill: {
                            patternType: "solid"
                            , fgColor: { rgb: "FFFFFF" }
                        }
                    }
                })
            }

            category.unshift(col_net)

            this.setState({
                DataSetCategory: [
                    {
                        columns: col_title
                        , data: []
                    },
                    {
                        columns: col_date
                        , data: []
                    }
                    , {
                        columns: col
                        , data: category
                    }],
                colCategory: col,
                rowsCategory: category
            });

            return this.state.DataSetCategory;
        } else {
            alert("ไม่พบวันที่");
            return;
        }
    }

    changeReport(event) {
        //event.target.value
        this.setState({
            [event.target.name]: event.target.value
        });

        if (event.target.value == "worksheet") {
            this.setState({
                report_title: 'Total Case & Detail Report (รายงานแสดงรายละเอียดแยกตามใบงาน)',
                project_disable: false
            })
            $('#src_project').prop("disabled", false);
            $('#src_category').prop("disabled", false);
            $('#src_group_type').prop("disabled", false);
            $('#src_service_type').prop("disabled", false);
            $('#src_channel').prop("disabled", false);
            $('#src_service_status').prop("disabled", false);
            $('#src_phonein').prop("disabled", false);
            $('#src_member').prop("disabled", false);
        } else if (event.target.value == "category") {
            this.setState({
                report_title: 'Category Summary Report (รายงานสรุปจำนวนใบงานแยกตามหมวดเรื่อง)',
                project_disable: true
            })
            $('#src_project').prop("disabled", true);
            $('#src_category').prop("disabled", true);
            $('#src_group_type').prop("disabled", true);
            $('#src_service_type').prop("disabled", true);
            $('#src_channel').prop("disabled", true);
            $('#src_service_status').prop("disabled", true);
            $('#src_phonein').prop("disabled", true);
            $('#src_member').prop("disabled", true);
        } else if (event.target.value == "status") {
            this.setState({
                report_title: 'Status Case Summary Report (รายงานสรุปจำนวนใบงานแยกตามสถานะ)',
                project_disable: true
            })
            $('#src_project').prop("disabled", true);
            $('#src_category').prop("disabled", true);
            $('#src_group_type').prop("disabled", true);
            $('#src_service_type').prop("disabled", true);
            $('#src_channel').prop("disabled", true);
            $('#src_service_status').prop("disabled", true);
            $('#src_phonein').prop("disabled", true);
            $('#src_member').prop("disabled", true);
        } else if (event.target.value == "project") {
            this.setState({
                report_title: 'Category  Summary  by Project Report (รายงานสรุปจำนวนใบงานแยกตามโครงการ)',
                project_disable: true
            })
            $('#src_project').prop("disabled", true);
            $('#src_category').prop("disabled", true);
            $('#src_group_type').prop("disabled", true);
            $('#src_service_type').prop("disabled", true);
            $('#src_channel').prop("disabled", true);
            $('#src_service_status').prop("disabled", true);
            $('#src_phonein').prop("disabled", true);
            $('#src_member').prop("disabled", true);
        }

    }

    render() {

        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
                padding: 3,
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: 6,
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);

        return (
            <div className="content-wrapper">
                <LoadingOverlay active={this.state.isActiveLoading} spinner text='Loading...' >
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0 text-dark">รายงาน ร้องเรียน/ข้อเสนอแนะทั่วไป</h1>
                                </div>{/* /.col */}
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href="/">Home</a></li>
                                        <li className="breadcrumb-item active">report</li>
                                    </ol>
                                </div>{/* /.col */}
                            </div>{/* /.row */}
                        </div>{/* /.container-fluid */}
                    </div>
                    {/* /.content-header */}
                    {/* Main content */}
                    <section className="content">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <form id="form-submit" onSubmit={this.handleSubmit}>
                                            <div className="row mt-3 mb-3">
                                                <div className="col-sm-1">
                                                    <img src={"../dist/img/icon/ic_report_head.png"} className="header-icon" />
                                                </div>
                                                <div className="col-sm-11">
                                                    <div className="row">
                                                        <div className="col-sm-2 text-right">โครงการ</div>
                                                        <div className="col-sm-6">
                                                            {/* <select className="form-control" id="src_project" name="src_project" style={{ height: 45, display: 'none' }} onChange={this.change}>
                                                                {
                                                                    this.state.project_home.map((datas) =>
                                                                        <option value={datas.value}>{datas.display}</option>)
                                                                }
                                                            </select> */}
                                                            {this.state.project_disable ? <Multiselect
                                                                disabled
                                                                data={this.state.project_home}
                                                                valueField='value'
                                                                textField='display'
                                                                value={this.state.src_project}
                                                                onChange={src_project => this.setState({ src_project: src_project })}
                                                            /> : <Multiselect
                                                                    data={this.state.project_home}
                                                                    valueField='value'
                                                                    textField='display'
                                                                    value={this.state.src_project}
                                                                    onChange={src_project => this.setState({ src_project: src_project })}
                                                                />}

                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-2 text-right">หมวดเรื่อง</div>
                                                        <div className="col-sm-3">
                                                            <select className="form-control" id="src_category" name="src_category" style={{ height: 45 }} onChange={this.change}>
                                                                {
                                                                    this.state.service_category.map((datas,index) =>
                                                                        <option key={index} value={datas.value}>{datas.display}</option>)
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className="col-sm-1 text-right">กลุ่มหัวข้อ</div>
                                                        <div className="col-sm-3">
                                                            <select className="form-control" id="src_group_type" name="src_group_type" style={{ height: 45 }} onChange={this.change}>
                                                                {
                                                                    this.state.group_type.map((datas,index) =>
                                                                        <option key={index} value={datas.value}>{datas.display}</option>)
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-2 text-right">เรื่องย่อย</div>
                                                        <div className="col-sm-3">
                                                            <select className="form-control" id="src_service_type" name="src_service_type" style={{ height: 45 }} onChange={this.change}>
                                                                {
                                                                    this.state.service_type.map((datas) =>
                                                                        <option value={datas.value}>{datas.display}</option>)
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className="col-sm-1 text-right">SLA</div>
                                                        <div className="col-sm-3">
                                                            <select className="form-control" id="src_sla" name="src_sla" style={{ height: 45 }} onChange={this.change}>
                                                                <option value=''>กรุณาเลือกข้อมูล</option>
                                                                <option value='normal'>Normal</option>
                                                                <option value='urgent'>Urgent</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-2 text-right">ช่องทางการติดต่อ</div>
                                                        <div className="col-sm-3">
                                                            <select className="form-control" id="src_channel" name="src_channel" style={{ height: 45 }} onChange={this.change}>
                                                                <option value="">เลือกช่องทางการติดต่อ</option>
                                                                {/* <option value="cc" >Call Center</option> */}
                                                                <option value="mobile" >Mobile Application</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-sm-1 text-right">สถานะ</div>
                                                        <div className="col-sm-3">
                                                            <select className="form-control" id="src_service_status" name="src_service_status" style={{ height: 45 }} onChange={this.change}>
                                                                <option value="">เลือกสถานะ</option>
                                                                <option value="progress">รับเรื่อง</option>
                                                                <option value="doing">กำลังดำเนินการ</option>
                                                                {/* <option value="coordinated">ประสานงานแล้ว</option> */}
                                                                <option value="cancel">ยกเลิก</option>
                                                                <option value="close">จบงาน</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-2 text-right">วันที่</div>
                                                        <div className="col-sm-3">
                                                            <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.src_startdate} id="src_startdate" name="src_startdate" className="form-control" onChange={this.changeStartDate} dateFormat="dd/MM/yyyy" />
                                                        </div>
                                                        <div className="col-sm-1 text-right">ถึง</div>
                                                        <div className="col-sm-3">
                                                            <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.src_enddate} id="src_enddate" name="src_enddate" className="form-control" onChange={this.changeEndDate} dateFormat="dd/MM/yyyy" />
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-2 text-right">เบอร์โทรเข้า</div>
                                                        <div className="col-sm-3">
                                                            <input type="text" className="form-control" id="src_phonein" name="src_phonein" onChange={this.change} />
                                                        </div>
                                                        <div className="col-sm-1 text-right">ผู้แจ้ง</div>
                                                        <div className="col-sm-3">
                                                            <input type="text" className="form-control" id="src_member" name="src_member" onChange={this.change} />
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-2 text-right">ประเภทรายงาน</div>
                                                        <div className="col-sm-5">
                                                            <select className="form-control" id="report_type" name="report_type" style={{ height: 45 }} onChange={this.changeReport}>
                                                                <option value="worksheet">รายงานแสดงรายละเอียดแยกตามใบงาน</option>
                                                                <option value="category">รายงานสรุปจำนวนใบงานแยกตามหมวดเรื่อง</option>
                                                                <option value="status">รายงานสรุปจำนวนใบงานแยกตามสถานะ</option>
                                                                <option value="project">รายงานสรุปจำนวนใบงานแยกตามโครงการ</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-12 text-right">
                                                            <button className="btn-advance" style={{ height: 45, float: "none" }} onClick={this.openView}>ค้นหารายการ</button>
                                                            <ExcelFile filename={(
                                                                this.state.report_type == "worksheet" && 'Total Case & Detail Report-' + moment().format('DDMMYYYY')
                                                                ||
                                                                this.state.report_type == "category" && 'Category Summary Report-' + moment().format('DDMMYYYY')
                                                                ||
                                                                this.state.report_type == "status" && 'Status Case Summary Report-' + moment().format('DDMMYYYY')
                                                                ||
                                                                this.state.report_type == "project" && 'Category  Summary  by Project Report-' + moment().format('DDMMYYYY')
                                                            )} element={(this.state.user_permission[60].permission == 1 &&
                                                                <button className="btn-advance" style={{ height: 45, float: "none" }}><img src={"../dist/img/icon/ic_print.png"} className="menu-icon" /> ดาวน์โหลด</button>
                                                            )}>
                                                                <ExcelSheet dataSet={this.state.dataReport} name="Organization" />
                                                            </ExcelFile>
                                                            <button className="btn-advance" style={{ height: 45, float: "none" }} onClick={this.clearData}>เคลียร์</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    {/* .card-header */}
                                    <div className="card-body" style={{ overflowX: 'auto' }}>
                                        <h4>{this.state.report_title}</h4>
                                        {(this.state.report_type == "worksheet" &&
                                            (<TableContainer component={Paper}>
                                                <Table aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell style={{ width: 30 }}>No</StyledTableCell>
                                                            <StyledTableCell style={{ width: 110 }}>วันที่รับเรื่อง</StyledTableCell>
                                                            <StyledTableCell style={{ width: 200 }}>ผู้แจ้ง</StyledTableCell>
                                                            <StyledTableCell style={{ width: 110 }}>เบอร์โทรเข้า</StyledTableCell>
                                                            <StyledTableCell style={{ width: 300 }}>โครงการ</StyledTableCell>
                                                            <StyledTableCell style={{ width: 80 }}>บ้านเลขที่</StyledTableCell>
                                                            <StyledTableCell style={{ width: 110 }}>สถานะประกัน</StyledTableCell>
                                                            <StyledTableCell style={{ width: 110 }}>เรื่อง</StyledTableCell>
                                                            <StyledTableCell style={{ width: 100 }}>ระยะประกัน</StyledTableCell>
                                                            <StyledTableCell>สถานะในงาน</StyledTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {
                                                            this.state.pages.slice(this.state.page * this.state.rowsPerPage,
                                                                this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data,index) => {
                                                                    return (
                                                                        <StyledTableRow key={index}>
                                                                            <StyledTableCell>{data.number}</StyledTableCell>
                                                                            <StyledTableCell>{data.service_date} {data.service_time}</StyledTableCell>
                                                                            <StyledTableCell>{data.member_name}</StyledTableCell>
                                                                            <StyledTableCell>{data.phone_come}</StyledTableCell>
                                                                            <StyledTableCell>{data.project_name}</StyledTableCell>
                                                                            <StyledTableCell>{data.home_number}</StyledTableCell>
                                                                            <StyledTableCell>{data.project_status}</StyledTableCell>
                                                                            <StyledTableCell>{data.category}</StyledTableCell>
                                                                            <StyledTableCell>{data.warranty_date}</StyledTableCell>
                                                                            <StyledTableCell>{data.service_status}</StyledTableCell>
                                                                        </StyledTableRow>)
                                                                })
                                                        }
                                                        {emptyRows > 0 && (
                                                            <StyledTableRow>
                                                                <StyledTableCell colSpan={6} />
                                                            </StyledTableRow>
                                                        )}
                                                    </TableBody>
                                                </Table>
                                                <TablePagination
                                                    rowsPerPageOptions={[10, 25, 50]}
                                                    component="div"
                                                    count={this.state.pages.length}
                                                    rowsPerPage={this.state.rowsPerPage}
                                                    page={this.state.page}
                                                    onChangePage={this.handleChangePage}
                                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                />
                                            </TableContainer>) ||
                                            //colCategory: col_date,
                                            //rowsCategory: category
                                            this.state.report_type == "category" &&
                                            (<Table className="report-preview">
                                                <thead>
                                                    {
                                                        this.state.colCategory.map(data => {
                                                            //console.log(data.title)
                                                            return (<th>{data.title}</th>)
                                                        })
                                                    }
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.rowsCategory.map(data => {
                                                            //console.log(data.title)
                                                            return (<tr>
                                                                {
                                                                    data.map(items => {
                                                                        return (<td style={
                                                                            {
                                                                                backgroundColor: "#" + items.style.fill.fgColor.rgb
                                                                                , color: "#" + (items.style.font.color === undefined ? "" : items.style.font.color)
                                                                            }}>{items.value}</td>)
                                                                    })
                                                                }
                                                            </tr>)
                                                        })
                                                    }
                                                </tbody>
                                            </Table>) ||
                                            this.state.report_type == "status" &&
                                            (<Table className="report-preview">
                                                <thead>
                                                    {
                                                        this.state.colStatus.map(data => {
                                                            //console.log(data.title)
                                                            return (<th>{data.title}</th>)
                                                        })
                                                    }
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.rowsStatus.map(data => {
                                                            //console.log(data.title)
                                                            return (<tr>
                                                                {
                                                                    data.map(items => {
                                                                        return (<td style={
                                                                            {
                                                                                color: "#" + (items.style.font.color === undefined ? "" : items.style.font.color)
                                                                            }}>{items.value}</td>)
                                                                    })
                                                                }
                                                            </tr>)
                                                        })
                                                    }
                                                </tbody>
                                            </Table>) ||
                                            this.state.report_type == "project" &&
                                            (<Table className="report-preview" style={{  width: this.state.colHeaderProj < window.innerWidth ? {wpx : window.innerWidth} : this.state.colHeaderProj}}>
                                                <thead>
                                                    <tr>
                                                        {
                                                            this.state.colProject.map((data, key) => {
                                                                return (<th style={{ width: (key == 0 && 300 || key == 1) }}>{data.title}</th>)
                                                            })
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.rowsProject.map((data, key) => {
                                                            //console.log(data.title)
                                                            return (<tr>
                                                                {
                                                                    data.map(items => {
                                                                        //check style ตรงนี้
                                                                        console.log(items.style)
                                                                        return (<td style={
                                                                            {
                                                                                backgroundColor: "#" + items.style.fill.fgColor.rgb
                                                                                , color: "#" + (items.style.font.color === undefined ? "" : items.style.font.color)
                                                                            }}>
                                                                            {items.value}
                                                                        </td>)
                                                                    })
                                                                }
                                                            </tr>)
                                                        })
                                                    }
                                                </tbody>
                                            </Table>)
                                        )
                                        }
                                    </div>
                                    {/* /.card-body */}
                                </div>
                                {/* /.card */}
                            </div>
                            {/* /.col */}
                        </div>
                        {/* /.row */}
                    </section>
                    {/* /.content */}
                </LoadingOverlay>
            </div>
        )
    }
}
export default withRouter(ReportHomeCare);
